var Component = require("!./../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!./../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-010db7cf!./../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./footer.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/js/components/partials/footer.vue
// module id = 1
// module chunks = 0